import React, { useEffect, useState } from 'react'
import Button from "../../material/button/Button"

import styles from './ModaluploadResults.module.css'
import Pagination from '../../pagination/Pagination'


export function ModaluploadResults({ dataList, onClose, onSubmit }) {

    const [keyList, setKeyList] = useState([])
    const [showList, setShowList] = useState([])
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(1)

    useEffect(() => {

        // console.log(dataList)
        let keyOfDataList = []
        Object.keys(dataList[0]).forEach(key => {
            keyOfDataList.push(key)
        });
        setKeyList(keyOfDataList)

        if (dataList.length > 0) {
            setTotalPage(Math.ceil(dataList.length / 3))
        }

    }, [dataList])


    useEffect(() => {
        let start = page * 3 - 3

        setShowList(dataList.slice(start, start + 3))

        // let list = []
        // for (let index = start; index < end; index += 1) {
        //     list.push(dataList[index])
        // }
        // setShowList(list)
    }, [page])

    return (
        <div className={styles.overlay}>
            <div className={styles.modalController}>
                <div className={styles.closeButton}>
                    <img onClick={() => { onClose() }} src={require('../../../asset/icon/close-icon.svg').default}></img>
                </div>
                <div className={styles.contentModal}>
                    <div className={styles.textTitle}>กรุณาตรวจสอบข้อมูลอีกครั้ง ก่อนทำการบันทึกลงในระบบ</div>
                    <div className={styles.textSubtitle}>จำนวนทั้งหมด {dataList.length} คน</div>
                    <hr className={styles.hrLine} />
                    <div className="scrollbar">
                        <table className={styles.tg}>
                            <thead>
                                <tr>
                                    {
                                        keyList.map(text => {
                                            return (
                                                <th>{text}</th>
                                            )
                                        })
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    showList.map(data => {
                                        return (
                                            <tr>
                                                {
                                                    keyList.map(key => {
                                                        return (
                                                            <td>{data[key]}</td>
                                                        )
                                                    })
                                                }
                                            </tr>
                                        )
                                    })
                                }




                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        clickForward={() => {
                            if (page < totalPage) {
                                setPage(page + 1)
                            }
                        }}
                        clickBackward={() => {
                            if (page > 1) {
                                setPage(page - 1)
                            }
                        }}
                        page={page}
                        totalpage={totalPage}
                    />
                    <div className={styles.align} style={{ margin: '30px 0px' }}>
                        <Button style={{ width: '200px' }} onClick={onSubmit}>บันทึกลงในระบบ</Button>
                    </div>
                    <div className={styles.textDetail}>**ท่านสามารถแก้ไขข้อมูลได้ภายใน 24 ชั่วโมงหลังจากกดยืนยันการลงข้อมูล กรุณาตรวจสอบข้อมูลให้ถูกต้อง**</div>
                </div>
            </div>
        </div>
    )
}